import React, { useState } from 'react';
import './components/SongList.css'; 

const Login = ({ onLogin }) => {
  // Modes: 'login', 'register', 'forgot'
  const [mode, setMode] = useState('login'); 
  const [formData, setFormData] = useState({ username: '', password: '', email: '' });
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  // --- DYNAMIC URL SETUP ---
  const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setLoading(true);
    
    // Use dynamic BASE_URL
    let url = `${BASE_URL}/api/login`;
    if (mode === 'register') url = `${BASE_URL}/api/register`;
    if (mode === 'forgot')   url = `${BASE_URL}/api/forgot-password`;

    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "Something went wrong");

      if (mode === 'login') {
        onLogin(data.token, data.username, data.plan, data.email);
      } else if (mode === 'register') {
        setMsg("Account created! Please log in.");
        setMode('login');
      } else if (mode === 'forgot') {
        setMsg("Check your email for the reset link!");
      }
    } catch (err) {
      setMsg(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h2 className="login-title">
          {mode === 'login' ? 'Sign In' : mode === 'register' ? 'Create Account' : 'Reset Password'}
        </h2>

        {msg && <div className={msg.includes("created") || msg.includes("email") ? "error-msg" : "error-msg"} style={{background: msg.includes("created") ? '#d4edda' : '', color: msg.includes("created") ? '#155724' : ''}}>{msg}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          {mode !== 'forgot' && (
             <input 
               name="username" 
               placeholder="Username" 
               value={formData.username}
               onChange={handleChange} 
               className="tool-input"
               required 
             />
          )}
          
          {(mode === 'register' || mode === 'forgot') && (
            <input 
              name="email" 
              type="email" 
              placeholder="Email Address" 
              value={formData.email}
              onChange={handleChange} 
              className="tool-input"
              required 
            />
          )}

          {mode !== 'forgot' && (
            <input 
              name="password" 
              type="password" 
              placeholder="Password" 
              value={formData.password}
              onChange={handleChange} 
              className="tool-input"
              required 
            />
          )}

          <button type="submit" className="btn-create-large" style={{ width: '100%', borderRadius: '8px' }} disabled={loading}>
            {loading ? 'Processing...' : (mode === 'login' ? 'Log In' : mode === 'register' ? 'Sign Up' : 'Send Reset Link')}
          </button>
        </form>

        <div className="login-toggle">
          {mode === 'login' && (
            <>
              <p>Need an account? <span onClick={() => {setMode('register'); setMsg("");}} className="login-link">Sign Up</span></p>
              <p style={{marginTop:'10px', fontSize:'0.9rem'}}>Forgot Password? <span onClick={() => {setMode('forgot'); setMsg("");}} className="login-link">Reset</span></p>
            </>
          )}
          {mode === 'register' && (
            <p>Have an account? <span onClick={() => {setMode('login'); setMsg("");}} className="login-link">Log In</span></p>
          )}
          {mode === 'forgot' && (
             <p><span onClick={() => {setMode('login'); setMsg("");}} className="login-link">Back to Login</span></p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
